<div class="db-tax-price-options mt20">
  <h1>
    <span>{{ 'text_pricesEnteredWithTax' | dbText }}</span>
    <i class="db-icon db-icon-info-lined"
       [dsTooltip]="infoTooltip"
       [dsTooltipSize]="'big'"
       dsTooltipAlign="left" dsTooltipPosition="top"></i>
  </h1>
  <div class="db-tax-price-options__list mt20" [ngClass]="{'automated': !!connectTaxesEnabled}">
    <div>
      <input class="ds-radio-black" type="radio" id="includeTax"
             [checked]="pricingIncluded === 'yes'"
             value="yes" name="radio" (click)="connectTaxes('yes')">
      <label for="includeTax">{{ 'text_yesIWillEnterPricesInclusiveOfTax' | dbText }}</label>
    </div>
    <div>
      <input class="ds-radio-black" type="radio" id="excludeTax"
             [checked]="pricingIncluded === 'no'"
             value="no" name="radio" (click)="connectTaxes('no')">
      <label for="excludeTax">{{ 'text_noIWillEnterPricesExclusiveOfTax' | dbText }}</label>
    </div>
  </div>
</div>

<ng-template #infoTooltip>
  <div class="db-info-tooltip-taxes-inform">
    <div class="db-info-tooltip-taxes">
      <div class="db-info-tooltip-taxes__content">
        <h2>{{ 'text_taxIsExcludedInThePrice' | dbText }}</h2>
        <div class="mt10">
          <p class="gray">
            <span>{{ 'text_item' | dbText }}</span>
            <span>$200</span>
          </p>
          <p class="gray">
            <span>{{ 'text_tax' | dbText }}</span>
            <span>$10</span>
          </p>
          <p>
            <span>{{ 'text_total' | dbText }}</span>
            <span>$200</span>
          </p>
        </div>
      </div>
      <div class="db-info-tooltip-taxes__content">
        <h2>{{ 'text_taxIsIncludedInThePrice' | dbText }}</h2>
        <div class="mt10">
          <p class="gray">
            <span>{{ 'text_item' | dbText }}</span>
            <span>$200</span>
          </p>
          <p class="gray">
            <span>{{ 'text_tax' | dbText }}</span>
            <span>$10</span>
          </p>
          <p>
            <span>{{ 'text_total' | dbText }}</span>
            <span>$210</span>
          </p>
        </div>
      </div>
    </div>
    <p class="mt12" [innerHTML]="'text_inCaseYouUseTheAutomatedTaxRates' | dbText"></p>
  </div>
</ng-template>
